<template>
  <v-container class="ma-0 pa-0 px-2 pt-8">
    <v-row dense justify="center" align="center">
      <v-col cols="12" class="text-center">
        <v-icon size="82" color="green">mdi-check-circle-outline</v-icon>
      </v-col>
      <v-col cols="12" class="text-center">
        Agendamento realizado com sucesso!!
      </v-col>
      <v-col cols="12" class="text-center mt-4" v-if="emailSent" >
        Uma mensagem de confirmação de agendamento acaba de ser enviada para o endereço: 
        <span class="font-weight-bold">{{ emailSent }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
  },
  data: () => ({
    result: null,
    emailSent: null,
  }),
  computed: {
  },
  created() {
    const query = this.$route.query;
    if (query && query.q) {
      this.result = JSON.parse(atob(query.q));
    }

    if(this.result) {
      this.emailSent = this.result.emailSent;
    }
  },
  methods: {
  },
  watch: {
  },
  components: {
  },
};
</script>
